module.exports = __webpack_public_path__ + "img/tiktok_default_thumbnail_no_play_btn.53fd22f5.png";